module.exports = __webpack_public_path__ + "static/assets/a9031bc84ad80f2eefa3b4c83d576dff.svg";